import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  PersonalFormoneData,
  PersonalFormTwoData,
  PersonalFormThreeData,
  PersonalFormFourData,
  PersonalFormFive,
} from "app/utils/types";

interface StepsDataTypes {
  formOne?: PersonalFormoneData;
  formTwo?: PersonalFormTwoData;
  formThree?: PersonalFormThreeData;
  formFour?: PersonalFormFourData;
  formFive?: PersonalFormFive;
}

interface StepState {
  currentStep: number;
  stepsData: StepsDataTypes;
}
const initialState: StepState = {
  currentStep: 0,
  stepsData: {},
};

export const personalDetails = createSlice({
  name: "personalDetails",
  initialState,
  reducers: {
    nextStep: (state) => {
      state.currentStep += 1;
    },
    prevStep: (state) => {
      if (state.currentStep >= 1) state.currentStep -= 1;
    },

    setStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    addStepsData: (state, action: PayloadAction<StepsDataTypes>) => {
      state.stepsData = { ...state.stepsData, ...action.payload };
    },
    resetStepsData: (state) => {
      state.stepsData = {};
      state.currentStep = 1;
    },
  },
});

export const { nextStep, prevStep, setStep, addStepsData } =
  personalDetails.actions;

export default personalDetails.reducer;
